import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 3v18h18V3H3zm6 14H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
}), 'PollSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PollSharp.js
// module id = 5550
// module chunks = 2